// removed by extract-text-webpack-plugin
module.exports = {"logForm":"logModal_logForm_DnCbh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/logModal/logModal.scss
// module id = 1540
// module chunks = 0